import { memo as Memo, useMemo, useEffect } from 'react'

//* HOCs
import withDataContext from 'context/consumerHOC/DataConsumer'
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Page from 'components/common/Page'
import ShareLink from 'components/common/ShareLink'
import Container from 'components/common/Container'
import Hero from 'components/pages/post/individual/HeroSection'
import LatestNews from 'components/pages/post/LatestNewsSection'
import PostContent from 'components/pages/post/individual/PostContentSection'
import GallerySlider from 'components/pages/post/individual/GallerySliderSection'

//* Style
import SingleNewsAndEventsStyle from 'styles/pages/SingleNewsAndEventsStyle'

const SingleNewsAndEvents = Memo(({ singleNewsAndEvents, pageParams, selectedLang, config, winWidth, setEventOrNews }) => {
    //! Page data
    const pageData = useMemo(() => singleNewsAndEvents?.[pageParams.selectedSlug]?.[selectedLang], [singleNewsAndEvents, pageParams, selectedLang])

    useEffect(() => {
        if (pageData) {
            setEventOrNews(pageData.post.type)
        }
    }, [pageData])

    return (
        <Page
            meta={pageData?.post?.meta}
            className={'single-news-and-events'}
        >
            {pageData && (
                <SingleNewsAndEventsStyle>
                    <Hero
                        title={pageData.post.title}
                        url={config.newsAndEvents.path}
                        image={pageData.post.hero_image}
                        type={pageData.post.type}
                        date={pageData.post.date}
                        place={pageData.post.place}
                        time={pageData.post.time}
                        text={pageData.post.featured_text}
                    />

                    <PostContent
                        date={pageData.post.date}
                        readTime={pageData.post.read_time}
                        description={pageData.post.description}
                        type={pageData.post.type}
                    />

                    {pageData.post.gallery && pageData.post.gallery.length > 0 && <GallerySlider data={pageData.post.gallery} />}

                    {pageData.latestNews && pageData.latestNews.length > 0 && (
                        <LatestNews
                            title={`latestNews`}
                            data={winWidth >= 768 && winWidth < 1024 ? pageData.latestNews.slice(0, 2) : pageData.latestNews.slice(0, 3)}
                        />
                    )}

                    {winWidth < 1024 && pageData.post.type === 'news' && (
                        <Container className={`mobile-share-link-wrapper`}>
                            <ShareLink />
                        </Container>
                    )}
                </SingleNewsAndEventsStyle>
            )}
        </Page>
    )
})
export default withUIContext(withDataContext(SingleNewsAndEvents, ['singleNewsAndEvents']), ['winWidth', 'setEventOrNews'])
